import { toBaseStudyEntity } from './study-entity.js';
import { toActivityType } from './allocation-activity-type.js';
import { checkDefined } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
export const allocationActivityNotesMaxLength = 250;
export function toAllocationActivity(allocationActivity) {
    checkDefined(allocationActivity.epochId, 'AllocationActivity', 'epochId');
    checkDefined(allocationActivity.parentId, 'AllocationActivity', 'parentId');
    checkDefined(allocationActivity.schemaId, 'AllocationActivity', 'schemaId');
    const type = allocationActivity.type != null ? toActivityType(allocationActivity.type) : undefined;
    return {
        ...toBaseStudyEntity(allocationActivity, StudyEntityType.AllocationActivity),
        schemaId: allocationActivity.schemaId,
        epochId: allocationActivity.epochId,
        parentId: allocationActivity.parentId,
        type: allocationActivity.type != null ? toActivityType(allocationActivity.type) : undefined,
        assessmentMeasurementConfigurationId: allocationActivity.assessmentMeasurementConfigurationId,
        scheduledDay: allocationActivity.scheduledDay,
        assessmentMeasurementId: type === 'stratification' ? allocationActivity.assessmentMeasurementId : undefined,
        unit: type === 'stratification' ? allocationActivity.unit : undefined,
        notes: allocationActivity.notes,
    };
}
//# sourceMappingURL=allocation-activity.js.map